<template>
  <div aria-hidden="true" class="onboarding-modal modal fade animated show" id="onboardingWideFormModal" role="dialog" tabindex="-1" style="display: block;">
    <div class="modal-dialog modal-lg modal-centered" role="document">
      <div class="modal-content">
        <div class="modal-header"><h5 class="modal-title" id="exampleModalLabel">Product Comments</h5>
            <button aria-label="Close" class="close" @click="closeModal" type="button"><span aria-hidden="true"> ×</span></button>
        </div>
        <Error v-if="state == 'error'" />
        <Loader v-if="state == 'loading'" :type="'modal'"/>
        <div class="modal-body" v-if="state == 'ready'">
            <div class="ticket-thread">
                <div class="ticket-reply" v-for="comment in productHistory.comments">
                    <div class="ticket-reply-info">
                        <a class="author with-avatar" href="#">
                            <img alt="" :src="'http://52.66.102.131/'+comment.avatar">
                            <span>{{comment.name}}</span>
                        </a>
                        <span class="info-data">
                            <span class="label">commented on</span>
                            <span class="value">{{comment.created_at}}</span>
                        </span>

                        <!-- <div class="actions" href="#"><i class="os-icon os-icon-ui-46"></i>
                            <div class="actions-list"><a href="#"><i class="os-icon os-icon-ui-49"></i><span>Edit</span></a><a href="#"><i
                                        class="os-icon os-icon-ui-09"></i><span>Mark Private</span></a><a href="#"><i class="os-icon os-icon-ui-03"></i><span>Favorite</span></a><a
                                    class="danger" href="#"><i class="os-icon os-icon-ui-15"></i><span>Delete</span></a></div>
                        </div> -->
                    </div>
                    <div class="ticket-reply-content">
                        {{comment.body}}
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import Error from '@/components/common/Error'
export default {
  props: ['product', 'productHistory', 'state'],
  components: { Loader, Error },
  methods: {
    closeModal: function () {
      this.$emit('modalInterface')
    }
  }
}
</script>

<style>

 {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  background-color: #fff;
  padding: 10px;
  -webkit-box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
          box-shadow: 0px 2px 4px rgba(126, 142, 177, 0.12);
  border-radius: 6px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
}

 .support-ticket-content {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  padding: 10px 30px;
  padding-right: 60px;
  position: relative;
}

 .support-ticket-content .support-ticket-content-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 30px;
  padding: 10px 0px;
}

 .support-ticket-content .support-ticket-content-header .show-ticket-info {
  margin-left: auto;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  padding-left: 20px;
  padding-top: 5px;
}

 .support-ticket-content .support-ticket-content-header h3,  .support-ticket-content .support-ticket-content-header h4 {
  margin-bottom: 0px;
}

 .support-ticket-content .show-ticket-info,
 .support-ticket-content .back-to-index {
  display: none;
  text-decoration: none;
  white-space: nowrap;
}

 .support-ticket-content .show-ticket-info span,
 .support-ticket-content .back-to-index span {
  display: inline-block;
  vertical-align: middle;
  text-transform: uppercase;
  color: #636c72;
  letter-spacing: 1px;
  font-size: 0.72rem;
  font-weight: 500;
}

 .support-ticket-content .show-ticket-info i,
 .support-ticket-content .back-to-index i {
  display: inline-block;
  vertical-align: middle;
  font-size: 19px;
}

 .support-ticket-content .show-ticket-info span + i,
 .support-ticket-content .back-to-index span + i {
  margin-left: 7px;
}

 .support-ticket-content .show-ticket-info:hover span,
 .support-ticket-content .back-to-index:hover span {
  color: #047bf8;
}

 .support-ticket-content .back-to-index i {
  font-size: 12px;
}

 .support-ticket-content .back-to-index span {
  margin-left: 10px;
}

 .ticket-header {
  margin-bottom: 40px;
}

 .ticket-reply {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding-bottom: 20px;
}

 .ticket-reply:last-child {
  border-bottom: none;
}

 .ticket-reply + .ticket-reply {
  margin-top: 20px;
}

 .ticket-reply .ticket-reply-info {
  padding: 10px 0px;
  margin-bottom: 5px;
  position: relative;
}

 .ticket-reply .ticket-reply-info .badge {
  vertical-align: middle;
  display: inline-block;
}

 .ticket-reply .ticket-reply-info .actions {
  position: absolute;
  top: 50%;
  right: 0px;
  -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
  font-size: 18px;
  color: #047bf8;
  text-decoration: none;
  cursor: pointer;
}

 .ticket-reply .ticket-reply-info .actions > i {
  vertical-align: middle;
  display: inline-block;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

 .ticket-reply .ticket-reply-info .actions .actions-list {
  position: absolute;
  background-color: #0f2338;
  color: #fff;
  font-size: 0.9rem;
  padding: 12px 12px;
  border-radius: 6px;
  visibility: hidden;
  opacity: 0;
  -webkit-transform: translateY(10px);
          transform: translateY(10px);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  top: 0px;
  right: 0px;
}

 .ticket-reply .ticket-reply-info .actions .actions-list a {
  display: block;
  padding: 5px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  color: #fff;
  text-decoration: none;
  white-space: nowrap;
}

 .ticket-reply .ticket-reply-info .actions .actions-list a:last-child {
  border-bottom: none;
}

 .ticket-reply .ticket-reply-info .actions .actions-list a i {
  font-size: 17px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  color: #fff;
}

 .ticket-reply .ticket-reply-info .actions .actions-list a span {
  color: rgba(255, 255, 255, 0.7);
  display: inline-block;
  vertical-align: middle;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

 .ticket-reply .ticket-reply-info .actions .actions-list a:hover span {
  color: #fff;
  -webkit-transform: translateX(-3px);
          transform: translateX(-3px);
}

 .ticket-reply .ticket-reply-info .actions .actions-list a.danger i {
  color: #ff5b5b;
}

 .ticket-reply .ticket-reply-info .actions .actions-list a.danger span {
  color: #ff5b5b;
}

 .ticket-reply .ticket-reply-info .actions:hover > i {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

 .ticket-reply .ticket-reply-info .actions:hover .actions-list {
  visibility: visible;
  -webkit-transform: translateY(0px);
          transform: translateY(0px);
  opacity: 1;
}

 .ticket-reply .ticket-reply-info .author {
  display: inline-block;
  vertical-align: middle;
}

 .ticket-reply .ticket-reply-info .info-data {
  display: inline-block;
  vertical-align: middle;
}

 .ticket-reply .ticket-reply-info .info-data .label {
  color: #636c72;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}

 .ticket-reply .ticket-reply-info .info-data .value {
  display: inline-block;
  vertical-align: middle;
}

 .ticket-reply .ticket-reply-info > span + span {
  margin-left: 10px;
}

 .ticket-reply .ticket-reply-content {
  padding: 20px 25px;
  margin-left: 15px;
  font-size: 0.99rem;
  background-color: #f3f3f7;
  border-radius: 6px;
}

 .ticket-reply .ticket-reply-content p:last-child {
  margin-bottom: 0px;
}

 .ticket-reply .ticket-attachments {
  text-align: right;
  margin-top: 10px;
}

 .ticket-reply .ticket-attachments .attachment {
  display: inline-block;
  padding: 5px 10px;
  padding-right: 20px;
  margin-bottom: 5px;
  background-color: #F6F7F8;
  color: #047bf8;
  border-radius: 6px;
  font-size: 0.72rem;
}

 .ticket-reply .ticket-attachments .attachment i {
  display: inline-block;
  vertical-align: middle;
  font-size: 18px;
  margin-right: 10px;
}

 .ticket-reply .ticket-attachments .attachment span {
  display: inline-block;
  vertical-align: middle;
}

 .ticket-reply .ticket-attachments .attachment + .attachment {
  margin-left: 20px;
}

 .ticket-reply.highlight .ticket-reply-info {
  border-bottom: none;
}

 .ticket-reply.highlight .ticket-reply-content {
  background-color: #fff6d7;
}

 .support-ticket-info {
  background-color: #F6F7F9;
  background: -webkit-gradient(linear, left top, left bottom, from(#eff1f7), to(#f9fafc));
  background: linear-gradient(to bottom, #eff1f7, #f9fafc);
  padding: 30px 20px;
  border-radius: 6px;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 250px;
          flex: 0 0 250px;
  position: relative;
}

 .support-ticket-info .close-ticket-info {
  position: absolute;
  top: 10px;
  right: 15px;
  color: #047bf8;
  text-decoration: none;
  font-size: 20px;
}
</style>
